import { gql } from 'urql';

export const healthyDealsCategoryListQuery = gql`
	query healthyDealsFilterList {
		healthyDealsFilterList {
			options {
				id
				label
			}
		}
	}
`;

export const healthyDealsFilterDealsQuery = gql`
	query healthyDealsFilterDeals(
		$skip: Int
		$take: Int
		$filterOptionIDs: [String!]
	) {
		healthyDealsFilterDeals(
			skip: $skip
			take: $take
			filterOptionIDs: $filterOptionIDs
		) {
			items {
				id
				dealName
				cardTitle
				dealType
				dealDescription
				dealDiscount
				dealImage {
					name
					altText
					imageXs {
						fileName
						url
						width
						height
					}
					imageSm {
						fileName
						url
						width
						height
					}
					imageMd {
						fileName
						url
						width
						height
					}
				}
				discountBadgeType
			}
			totalCount
		}
	}
`;

export const healthyDealsAFDDetailsQuery = gql`
	query healthyDealsDealDetail($dealId: String!) {
		healthyDealsDealDetail(dealId: $dealId) {
			id
			dealName
			cardTitle
			dealType
			detailsLogo {
				fileName
				url
			}
			detailsTitle
			detailsIntro
			detailsHeroImage {
				name
				altText
				imageXs {
					fileName
					url
					width
					height
				}
				imageSm {
					fileName
					url
					width
					height
				}
				imageMd {
					fileName
					url
					width
					height
				}
			}
			detailsHeroVideo {
				fileName
				url
			}
			detailsDescriptionTitle
			detailsDescription
			detailsContentTitleImageWidget {
				title
				content
				image {
					name
					imageXs {
						fileName
						url
						width
						height
					}
					imageSm {
						fileName
						url
						width
						height
					}
					imageMd {
						fileName
						url
						width
						height
					}
				}
			}
			detailsDisclaimer
			vendorLink
			recommendedDeals {
				id
				dealName
				cardTitle
				dealType
				dealDescription
				dealDiscount
				dealImage {
					name
					altText
					imageXs {
						fileName
						url
						width
						height
					}
					imageSm {
						fileName
						url
						width
						height
					}
					imageMd {
						fileName
						url
						width
						height
					}
				}
				discountBadgeType
			}
		}
	}
`;

export const healthyDealsVendorDetailsQuery = gql`
	query healthyDealsDealDetail($dealId: String!) {
		healthyDealsDealDetail(dealId: $dealId) {
			id
			dealName
			cardTitle
			dealType
			detailsLogo {
				fileName
				url
			}
			detailsTitle
			detailsIntro
			detailsHeroImage {
				name
				altText
				imageXs {
					fileName
					url
					width
					height
				}
				imageSm {
					fileName
					url
					width
					height
				}
				imageMd {
					fileName
					url
					width
					height
				}
			}
			detailsDescriptionTitle
			detailsDescription
			promoCode
			howToSectionStep1CustomText
			promoCodeType
			vendorLink
			recommendedDeals {
				id
				dealName
				cardTitle
				dealType
				dealDescription
				dealDiscount
				dealImage {
					name
					altText
					imageXs {
						fileName
						url
						width
						height
					}
					imageSm {
						fileName
						url
						width
						height
					}
					imageMd {
						fileName
						url
						width
						height
					}
				}
				discountBadgeType
			}
		}
	}
`;

export const healthyDealsSpecialtyDetailsQuery = gql`
	query healthyDealsDealDetail($dealId: String!) {
		healthyDealsDealDetail(dealId: $dealId) {
			id
			dealName
			cardTitle
			dealType
			detailsTitle
			detailsHeroImage {
				name
				altText
				imageXs {
					fileName
					url
					width
					height
				}
				imageSm {
					fileName
					url
					width
					height
				}
				imageMd {
					fileName
					url
					width
					height
				}
			}
			detailsDescriptionTitle
			detailsDescription
			detailsContentTitleImageWidget {
				title
				content
				image {
					name
					imageXs {
						fileName
						url
						width
						height
					}
					imageSm {
						fileName
						url
						width
						height
					}
					imageMd {
						fileName
						url
						width
						height
					}
				}
			}
			detailsQuestionAnswerWidgetTitle
			detailsQuestionAnswerWidget {
				question
				answer
			}
			detailsAuthor
			detailsReferences
			vendorLink
			recommendedDeals {
				id
				dealName
				cardTitle
				dealType
				dealDescription
				dealDiscount
				dealImage {
					name
					altText
					imageXs {
						fileName
						url
						width
						height
					}
					imageSm {
						fileName
						url
						width
						height
					}
					imageMd {
						fileName
						url
						width
						height
					}
				}
				discountBadgeType
			}
		}
	}
`;
